import { render, staticRenderFns } from "./PrazoEntregaMunicipios.vue?vue&type=template&id=ca350676"
import script from "./PrazoEntregaMunicipios.vue?vue&type=script&lang=js"
export * from "./PrazoEntregaMunicipios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports